import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { finalisedListTable, finalisedTableOptions } from "../../../shared/tableObjects/admin/finalisedListTable";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";

export default function FinalisedList() {
  const apiClient = useApiClient("BaseApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of Finalised Assessments",
      icon: "list-icon",
    },
  ];
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />{" "}
        <Table apiClient={apiClient} label={""} columns={finalisedListTable("finalised")} tableOptions={finalisedTableOptions} />
      </div>
    </>
  );
}
